import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { IApplicationContext } from 'shared/types/applicationContext';
import { IPreloadedState } from 'shared/types/redux';
import { experimentsReducer } from 'shared/slices/experiments';
import { landingTypeReducer } from '../../slices/landingType';
import { authenticationWidgetReducer } from '../../slices/authenticationWidget';
import * as activateInsurance from '../../slices/activateInsurance';
import * as joinOtaIndividual from '../../slices/joinOtaIndividual';
import * as joinOtaLegalShort from '../../slices/joinOtaLegalShort';
import * as redirect from '../../slices/redirect';
import * as externalParams from '../../slices/externalParams';
import * as businessEntityFlow from '../../slices/businessEntityFlow';
import * as userVerificationError from '../../slices/userVerificationError';

/**
 * Хелпер для создания Redux стора
 * @param context IApplicationContext - контекст приложения
 * @param preloadedState IPreloadedState - предзагруженное состояние
 * @param debugEnabled boolean - флаг доступности Redux Devtools на деве
 */
export function createReduxStore(context: IApplicationContext, preloadedState: IPreloadedState, debugEnabled: boolean) {
  const projectName = context.config.getStrict<string>('projectName');

  return configureStore({
    devTools: debugEnabled ? { name: projectName } : false,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: context,
        },
      }),
    preloadedState,
    reducer: {
      externalParams: externalParams.externalParamsReducer,
      userVerificationError: userVerificationError.userVerificationErrorReducer,

      authenticationWidget: authenticationWidgetReducer,
      landingType: landingTypeReducer,

      activateInsurance: combineReducers({
        stepsConfiguration: activateInsurance.stepsConfigurationReducer,
      }),

      joinOtaIndividual: combineReducers({
        isLoading: joinOtaIndividual.isLoadingReducer,
        stepsConfiguration: joinOtaIndividual.stepsConfigurationReducer,
        formData: joinOtaIndividual.formDataReducer,
        insurance: joinOtaIndividual.insuranceReducer,
      }),

      joinOtaLegalShort: combineReducers({
        isLoading: joinOtaLegalShort.isLoadingReducer,
        stepsConfiguration: joinOtaLegalShort.stepsConfigurationReducer,
        legalData: joinOtaLegalShort.legalDataReducer,
      }),

      businessEntityFlow: combineReducers({
        businessEntityValidation: businessEntityFlow.businessEntityValidation,
        stepsConfiguration: businessEntityFlow.stepsConfigurationReducer,
      }),

      redirect: redirect.redirectReducer,
      experiments: experimentsReducer,
    },
  });
}
